//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
import React, { useEffect, useState } from "react";
import { Card, Alert } from "react-bootstrap";
import { commonMessages } from "../../JSON/commonMessages";

const ErrorAlertMessage = ({ alertMessage, showAlert }) => {

    const fetchCommonMessage = (key) => {
        let refCmsContent = commonMessages && commonMessages;
        let label = "";
        if (refCmsContent) {
            refCmsContent.map((x) => {
                if (x.Key === key) {
                    label = x.Phrase;
                }
            });
        }
        return label;
    }

    const [show, setShow] = useState(true)

    useEffect(() => {
        const timeId = setTimeout(() => {
            setShow(false)
            showAlert()

        }, 5000)

        return () => {
            clearTimeout(timeId)
        }
    }, []);

    return (
        <div>
            {show ?
                <Card>
                    <Card.Body>
                        <Alert variant="danger" onClose={() => showAlert()} dismissible>
                            <div className="alert-message">
                                <strong>{fetchCommonMessage(alertMessage)}</strong>
                            </div>
                        </Alert>
                    </Card.Body>
                </Card>
                : ""
            }
        </div>
    )
};

export default ErrorAlertMessage;
